// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-routes-App-components-GetTheAppHeader-GetTheAppHeader__base--xxIkW{padding:10px;color:#fff;display:flex;justify-content:center;align-items:center;background:#2980b9;flex-wrap:wrap;font-size:1.2em;font-weight:500}.src-routes-App-components-GetTheAppHeader-GetTheAppHeader__base--xxIkW>span{margin:5px 0}.src-routes-App-components-GetTheAppHeader-GetTheAppHeader__base--xxIkW>div{display:flex}.src-routes-App-components-GetTheAppHeader-GetTheAppHeader__base--xxIkW>div>*{margin-left:5px}\n", ""]);
// Exports
exports.locals = {
	"base": "src-routes-App-components-GetTheAppHeader-GetTheAppHeader__base--xxIkW"
};
module.exports = exports;
